/* ============
 * Getters for the vivemas module
 * ============
 *
 * The getters that are available on the
 * vivemas module.
 */

export default {
  assists: state => { return state.assists },
  benefits: state => { return state.benefits },
  assistCategories: state => { return state.assistCategories },
  benefitCategories: state => { return state.benefitCategories },
  brads: state => { return state.brads },
  cities: state => { return state.cities }
}



// WEBPACK FOOTER //
// ./src/store/modules/vivemas/getters.js